import React, { useEffect, useState } from 'react';
import divider from '../../assets/divider.svg';
import { Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import bgImage from '../../assets/bgImage.jpeg';
import Sale from '../../assets/Sale.png';
import { useFilterContext } from '../../context/filter_context';
import axios from 'axios';
import Loading from '../Loading';
import { useProductsContext } from '../../context/products_context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const Categories = () => {
  const {
    filtered_products: products,
    grid_view,
  } = useFilterContext();
  const [isLoading, setIsLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const {fetchProducts}=useProductsContext()

  const history=useHistory()
  useEffect(() => {
    const fetchData= async () => {
      setIsLoading(true);
      let res = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/category/all`
      );
      setCategoryData(res.data.data);
      setIsLoading(false);
    };
    fetchData();
  }, []);

    return (
    <div className='flex flex-col bg-white h-auto w-full p-4'>
      {!isLoading && (
        <>
          {' '}
          <h1 className='flex justify-center items-center text-[#010535] font-[600] text-xl'>
            Shop by category
          </h1>
          <div className='flex justify-center items-center py-2 gap-3'>
            <div className='border border-x-2 border-[#F4B41A] w-[30%]'></div>
            <img src={divider} />
            <div className='border border-[#F4B41A] w-[30%]'></div>
          </div>
          <div className='w-full flex-wrap justify-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2'>
            {categoryData?.filter((_, index) => index < 5).map((e) => {
              return (
                <Link to={`/collections?category=${e.categoryName}`}>
                <div className='flex flex-col justify-center items-center p-2 gap-4 w-full'>
                  <img
                    src={e?.categoryImages[0]}
                    className='rounded-lg h-auto w-full'
                  />
                  <div className='flex flex-col gap-1 justify-center items-center'>
                    <p className='text-[#010535] font-[600] text-lg'>
                      {e?.categoryName}
                    </p>

                    <p
                      className='text-[#D3A143]'
                      // onClick={() => handleSelectCategory(e.categoryName)}
                    >
                      Explore {'>'}
                    </p>
                  </div>
                </div>
                </Link>
              );
            })}
          </div>
          <div className='flex justify-center items-center py-2 w-full gap-3 mb-4'>
            <div className='border border-x-2 border-[#F4B41A] w-[30%]'></div>
            <Link to={'/collections'}>
              <Button backgroundColor='#D3A143' color='white' fontWeight={400}>
                View More
              </Button>
            </Link>
            <div className='border border-[#F4B41A] w-[30%]'></div>
          </div>
          <div
            className='bg-cover bg-center object-contain h-[50vh] w-full flex flex-col justify-center items-center gap-4'
            style={{ backgroundImage: `url(${bgImage})` }}
          >

          </div>
        </>
      )}
      {isLoading && <Loading />}
    </div>
  );
};

export default Categories;
